var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.25,
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#8E0229"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.25,
    cx: 60.001,
    cy: 60,
    r: 50,
    fill: "#D21E50"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 36,
    fill: "#D21E50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3955 68.2498L57.645 60.0002L49.3955 51.7506L51.7525 49.3936L60.0021 57.6431L68.2517 49.3936L70.6087 51.7506L62.3591 60.0002L70.6087 68.2498L68.2517 70.6068L60.0021 62.3572L51.7525 70.6067L49.3955 68.2498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.efc9bbffc0498f959dae4edc1622ae57.svg";
export { ForwardRef as ReactComponent };